@if (
  isCustomerEmulationSessionInProgress$ | async) {
  <input
    formcontrolname="customer"
    type="text"
    disabled="true"
    placeholder="{{ customer?.name }}, {{ customer?.uid }}"
    />
  <button class="end-session" (click)="logoutCustomer()">
    {{ "asm.endSession" | cxTranslate }}
  </button>
} @else {
  @if (isCollapsed$) {
    <vsca-cx-customer-selection
      (submitEvent)="startCustomerEmulationSession($event)"
    ></vsca-cx-customer-selection>
  }
}

